// Normalizzazione degli assi quantitativi dei radar (Analytics).
//
// Con REACT_APP_OPEN_DATASET=true il punteggio 0-6 di GHG/Water/Energy è il
// PERCENTILE del materiale nella distribuzione del dataset (6 = tra i
// materiali a impatto più basso, 0 = più alto): metodo dichiarato nel
// sottotitolo del grafico, robusto agli outlier (es. acqua della seta) e
// auto-aggiornante quando i dati cambiano.
// Con flag off restano le formule storiche del 2025 (build identica a prima).
// L'asse Fossil Fuel resta qualitativo/editoriale e non passa da qui.

export const OPEN_DATASET_RADAR = process.env.REACT_APP_OPEN_DATASET === 'true';

export const RADAR_METHOD_NOTE =
  'GHG / Water / Energy axes: percentile of the material within the sustAId ' +
  'open dataset distribution (6 = among the lowest-impact materials, 0 = highest). ' +
  'Fossil fuel: editorial level. Sustainability: editorial score.';

const METRIC_KEYS = {
  ghg: 'GHG Emissions (kg CO2e/kg)',
  water: 'Water Consumption (L/kg)',
  energy: 'Energy Use (MJ/kg)'
};

// Formule del 2025, conservate per il flag off.
const LEGACY_DIVISORS = { ghg: 10, water: 200, energy: 20 };

// Stessa semantica di parsing usata da grafici e warning: primo numero
// della stringa; N/A o assenza di cifre = dato mancante.
export const parseMetricNumber = (raw) => {
  const str = String(raw || '');
  if (str.toUpperCase().includes('N/A')) return null;
  const match = str.match(/[\d.]+/);
  return match ? parseFloat(match[0]) : null;
};

// Costruisce una funzione (material, code) -> punteggio 0-6.
// Le distribuzioni si calcolano una volta su tutti i materiali passati.
export function buildImpactScorer(materials) {
  const distributions = {};
  Object.entries(METRIC_KEYS).forEach(([code, key]) => {
    distributions[code] = materials
      .map((m) => parseMetricNumber(m[key]))
      .filter((v) => v !== null)
      .sort((a, b) => a - b);
  });

  return (material, code) => {
    const value = parseMetricNumber(material[METRIC_KEYS[code]]);
    if (value === null) return 0; // come prima: senza dato l'asse è 0 (e scatta il MissingDataWarning)

    if (!OPEN_DATASET_RADAR) {
      return Math.max(0, Math.min(6, 7 - value / LEGACY_DIVISORS[code]));
    }

    const values = distributions[code];
    if (values.length < 2) return 3; // distribuzione insufficiente: neutro

    // Rango con gestione dei pari merito (posizione media del blocco di uguali)
    let first = 0;
    while (first < values.length && values[first] < value) first++;
    let last = values.length - 1;
    while (last >= 0 && values[last] > value) last--;
    const rank = (first + Math.max(first, last)) / 2;

    const percentile = rank / (values.length - 1);
    return Math.round(6 * (1 - percentile) * 100) / 100;
  };
}
